import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { WorkspaceName } from "@components/workspace/WorkspaceName";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";

export const WorkWorkspaceNameCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsWorkOverviewRow,
        string | undefined
    >) => {
        if (row.original.rowType !== "work") {
            return null;
        }

        return (
            <ViewTableCell>
                <WorkspaceName
                    workspace={{
                        id: row.original.workspaceId,
                        name: row.original.workspaceName,
                    }}
                    isIconVisible={false}
                />
            </ViewTableCell>
        );
    },
);

WorkWorkspaceNameCell.displayName = "WorkWorkspaceNameCell";
